import { useQuery } from '@apollo/client';
import { GET_JOIN_COUNT } from '../../helpers/graphql/onboarding';

// Social proof from live signup numbers — same data and visibility
// thresholds as the legacy Header/JoinCount box, restyled as a journal chip.
// Falls back to the all-time member count (pass it from GET_USER_COUNT)
// when the recent numbers are too small to brag about.
export default function JoinProofChip({ fallbackCount, className = '' }) {
  const { data } = useQuery(GET_JOIN_COUNT);
  const counts = data && data.getJoinCount;
  const hasRecent =
    counts &&
    (counts.day || counts.week) &&
    !(counts.day < 2 && counts.week < 4);

  let text;
  if (hasRecent) {
    text =
      counts.day > 2
        ? `${counts.day} new travelers joined today`
        : `${counts.week} new travelers joined this week`;
  } else if (fallbackCount) {
    text = `join ${Number(fallbackCount).toLocaleString(
      'en-US',
    )}+ travelers · est. 2018`;
  } else {
    return null;
  }

  return (
    <span
      className={`tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-primary-600/10 dark:tw-bg-primary-300/15 tw-px-3.5 tw-py-1.5 tw-font-mono tw-text-[10px] tw-font-semibold tw-uppercase tw-tracking-[0.18em] tw-text-primary-700 dark:tw-text-primary-300 ${className}`}
    >
      <span
        className="tw-h-1.5 tw-w-1.5 tw-animate-pulse tw-rounded-full tw-bg-primary-600 dark:tw-bg-primary-300"
        aria-hidden="true"
      />
      {text}
    </span>
  );
}
